import {importProvidersFrom, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuard} from "./shared/guards/auth.guard";
import {MfaEnforcementGuard} from "./shared/guards/mfa-enforcement.guard";
import {TranslateService} from "@ngx-translate/core";
import {Location} from "@angular/common";
import {
  LocalizeParser,
  LocalizeRouterModule,
  LocalizeRouterSettings,
} from "@gilsdav/ngx-translate-router";
import {createLocalizeRouterTranslateLoader} from "./models/translator";


export const dash_routes: Routes = [
  {
    path: "platform-setup",
    loadComponent: () =>
      import("./smart-dining-dash/components/platform-setup/platform-setup-wizard.component").then(
        (m) => m.PlatformSetupWizardComponent,
      ),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule,
      ),
  },
  {
    path: "sign-contract",
    loadComponent: () =>
      import("./smart-dining-dash/components/sale-leads/contract-sign-page/contract-sign-page.component").then(
        (m) => m.ContractSignPageComponent,
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./smart-dining-dash/smart-dining-dash.module").then(
        (m) => m.SmartDiningDashModule,
      ),
    canActivate: [AuthGuard, MfaEnforcementGuard],
  },
];

const routes: Routes = [
  {
    path: "",
    children: dash_routes
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      onSameUrlNavigation: "reload",
      anchorScrolling: "disabled",
    }),
  ],
  exports: [RouterModule],
  providers: [
    importProvidersFrom(
      LocalizeRouterModule.forRoot(routes, {
        parser: {
          provide: LocalizeParser,
          useFactory: (createLocalizeRouterTranslateLoader),
          deps: [TranslateService, Location, LocalizeRouterSettings]
        },
        initialNavigation: true
      }),
    )
  ],
})
export class AppRoutingModule { }
